import React, { useState } from 'react';
import CollapsibleSection from '../CollapsibleSection';
import WorkoutCompositionPicker from '../WorkoutCompositionPicker';
import IaOnboardingPackModal from '../IaOnboardingPackModal';
import { MAX_REGENERATION_ROUNDS } from '../../constants/workoutWizardSteps';

export default function WizardStepReview({
  suggestions,
  perWorkoutNotes,
  engineLabel,
  globalNotes,
  onGlobalNotesChange,
  extraDetail,
  onExtraDetailChange,
  workoutComposition,
  onWorkoutCompositionChange,
  draftSavedAt,
  onPerWorkoutNoteChange,
  onRemoveSuggestion,
  onClearDraft,
  onApplyOne,
  onApplyAll,
  onRegenerate,
  applyLoading,
  canRegenerate,
  regenerationRound,
}) {
  const [adjustOpen, setAdjustOpen] = useState(false);
  const roundsLeft = MAX_REGENERATION_ROUNDS - regenerationRound;

  return (
    <div className="space-y-4">
      <div>
        <p className="font-mono text-[10px] uppercase tracking-wider text-iron-accent">Revisão do pack</p>
        <p className="mt-1 text-xs text-iron-muted">
          Expanda cada treino, ajuste se precisar e crie todos na sua conta.
        </p>
      </div>

      <CollapsibleSection title="Ajustar pedido" open={adjustOpen} onOpenChange={setAdjustOpen}>
        <div className="space-y-3">
          <WorkoutCompositionPicker
            value={workoutComposition}
            onChange={(next, meta) => onWorkoutCompositionChange?.(next, meta)}
            title="Composição"
          />
          <label className="block">
            <span className="font-mono text-[10px] text-iron-muted">Contexto geral</span>
            <textarea
              value={globalNotes}
              onChange={(e) => onGlobalNotesChange?.(e.target.value)}
              rows={2}
              className="input mt-1 min-h-[60px] resize-y font-mono text-xs"
            />
          </label>
          <label className="block">
            <span className="font-mono text-[10px] text-iron-muted">Pedido extra</span>
            <textarea
              value={extraDetail}
              onChange={(e) => onExtraDetailChange?.(e.target.value)}
              rows={2}
              className="input mt-1 min-h-[60px] resize-y font-mono text-xs"
            />
          </label>
        </div>
      </CollapsibleSection>

      {!canRegenerate ? (
        <p className="rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 font-mono text-[10px] text-amber-100/90 text-center">
          Última ronda — regenerações esgotadas. Aprove o pack atual.
        </p>
      ) : (
        <button
          type="button"
          className="btn-secondary btn-sm w-full"
          onClick={onRegenerate}
          disabled={applyLoading}
        >
          Regenerar pack ({roundsLeft} restante{roundsLeft === 1 ? '' : 's'})
        </button>
      )}

      <IaOnboardingPackModal
        embedded
        open
        mode="review"
        suggestions={suggestions}
        loading={applyLoading}
        engineLabel={engineLabel}
        perWorkoutNotes={perWorkoutNotes}
        onPerWorkoutNoteChange={onPerWorkoutNoteChange}
        onRemoveSuggestion={onRemoveSuggestion}
        onClearDraft={onClearDraft}
        onApplyOne={onApplyOne}
        onApplyAll={onApplyAll}
        draftSavedAt={draftSavedAt}
      />
    </div>
  );
}
